// TODO: fix the types
export default function Drafts({
  onSelect,
}: {
  onSelect: (item: any) => void;
}) {
  const data: any[] = [];

  if (!data.length)
    return <p className="text-center text-sm text-gray-400">No drafts found</p>;

  return (
    <div className="space-y-2">
      {data.map((item) => (
        <div
          key={item.id}
          onClick={() => onSelect(item)}
          className="flex justify-between p-2 hover:bg-gray-100 rounded-md cursor-pointer"
        >
          <div>
            <p className="font-medium">{item.name}</p>
            <p className="text-xs text-gray-500">{item.id}</p>
          </div>
          <p className="text-xs text-gray-500">{item.date}</p>
        </div>
      ))}
    </div>
  );
}

/* Expanded view for a single Draft item */
Drafts.Expanded = function DraftsExpanded({
  item,
  onClose,
}: {
  item: any;
  onClose: () => void;
}) {
  return (
    <div className="card h-full">
      <button onClick={onClose} className="mb-2 text-sm text-blue-500">
        ← Back
      </button>
      <h2 className="text-lg font-semibold mb-2">{item.name}</h2>
      <p className="text-sm text-gray-500">ID: {item.id}</p>
      <p className="mt-4 text-sm">More detailed draft info here...</p>
    </div>
  );
};
